
/*
  Utility proxy class to encapsulate event subscriptions

  Example:


  const listener = new EventListener()
  listener.subscribeTo(eventEmitter)
  listener.on('message', msg => console.log(msg))
  listener.on(['event1', 'event2'], msg => console.log(msg))

  -- on destroy
  listener.unsubscribe()
*/
export class EventListener {

  constructor() {
    this.eventEmitter = null
    this.subscriptions = []
  }

  ckeckForEventEmitter() {
    if (this.eventEmitter === null) {
      throw new Error('Subscribe to an EventEmitter first')
    }
  }

  subscribeTo(eventEmitter) {
    if (this.eventEmitter !== null) {
      throw new Error('The EventListener has been already subscribed to an EventEmitter')
    }
    this.eventEmitter = eventEmitter
  }

  getEventEmitter() {
    return this.eventEmitter
  }

  on(event, fn) {
    if (Array.isArray(event)) {
      event.forEach(event => {
        this._on(event, fn)
      })
    } else {
      this._on(event, fn)
    }
    return this
  }

  off(event, fn) {
    if (Array.isArray(event)) {
      event.forEach(event => {
        this._off(event, fn)
      })
    } else {
      this._off(event, fn)
    }
    return this
  }

  _on(event, fn) {
    this.ckeckForEventEmitter()
    this.eventEmitter.on(event, fn)
    this.subscriptions.push({ event, fn })
    return this
  }

  _off(event, fn) {
    this.ckeckForEventEmitter()
    this.eventEmitter.off(event, fn)
    this.subscriptions = this.subscriptions.filter(
      (sub) => !(sub.event === event && sub.fn === fn))
    return this
  }

  unsubscribe() {
    this.ckeckForEventEmitter()
    this.subscriptions.slice().forEach(sub =>
      this.off(sub.event, sub.fn))

    this.subscriptions = []
    this.eventEmitter = null
  }
}


// WEBPACK FOOTER //
// ./utilities/eventListener.js